<template>
  <tr
    class="tw-cursor-pointer"
    :data-testid="`document-entry-${entry.title}-${
      selected ? 'selected' : 'unselected'
    }`"
    @click="emit('toggleSelection', entry)"
  >
    <td
      ref="titleRef"
      v-tooltip="titleTooltip"
      :class="highlightClass"
      class="tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap"
    >
      {{ entry.title }}
    </td>
    <td :class="highlightClass">{{ entry.exportedBy }}</td>
    <td :class="highlightClass">{{ date }}</td>
    <td :class="highlightClass" class="sf-table-button-cell">
      <SfButtonIcon seamless icon="eye" large-icon @click="openUrl" />
    </td>
  </tr>
</template>

<script setup lang="ts">
import communicationDate from '@app/utils/communication-date'
import { computed, ref } from 'vue'
import useDynamicTooltip from '@app/shared/vue/composables/use-dynamic-tooltip'
import { ExportType } from '@app/application/export/types'
import { SfButtonIcon } from '@app/shared/vue/components/sf-button'

interface Props {
  selected: boolean
  entry: ExportType
}

const props = defineProps<Props>()

const emit = defineEmits<{ toggleSelection: [ExportType] }>()

const titleRef = ref<HTMLElement | null>(null)
const titleTooltip = useDynamicTooltip(titleRef, props.entry.title)

const highlightClass = computed(() =>
  props.selected ? 'sf-bg-primary-subtle' : ''
)

const date = computed(() => communicationDate(props.entry.createdAt))

function openUrl() {
  window.open(props.entry.url)
}
</script>

<style scoped lang="scss">
// .sf-table-bordered has styles that can't be overriden with tailwind
td.sf-table-button-cell {
  padding: 2px 6px;
}
</style>
